import { render, staticRenderFns } from "./DetailedEstimate.vue?vue&type=template&id=2123ff00&"
import script from "./DetailedEstimate.vue?vue&type=script&lang=js&"
export * from "./DetailedEstimate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports